import React, { useEffect, useState } from "react";
import { Container, ViewVideo, ContentIcon } from "./style";
import {
  SubTitle,
  SmallText,
  FooterText,
} from "../../config/theme/globalStyles";
import { MaterialIcons, Octicons } from "@expo/vector-icons";
import THEME from "../../config/theme";
import { AlertBox } from "../AlertBox";
import { VideoUpload } from "../VideoAudioPicker";
import { ActivityIndicator, Provider, Chip } from "react-native-paper";
import { PdfUpload } from "../PdfPicker";
import VideoPlayer from "../VideoPlayer";
import {
  TouchableOpacity,
  Pressable,
  Modal,
  View,
  Text,
  Picker,
  StyleSheet,
} from "react-native";
import { CheckBox } from "react-native-elements";
import { Calendar, LocaleConfig } from "react-native-calendars";
import { getFunctions, httpsCallable } from "firebase/functions";
import { firestore } from "../../services/firebase";
import { deleteField, doc, getDoc, updateDoc } from "firebase/firestore";
import { PDFUploader } from "../PDFUploader";
import ConfirmDeleteModal from "../ConfirmDeleteModal";
import { useCustomTheme } from "../../contexts/useCustomTheme";
import { normalizeZoomMeetingNumber } from "../../utils/validators";
import AdminInput from "../AdminInput";
import { LiveScheduleFields } from "./LiveScheduleFields";
import { ADMIN_COLORS, ADMIN_FONT } from "../../config/theme/adminColors";
import {
  SectionCard,
  Field,
  FieldLabel,
  Row,
  Col,
  InfoBanner,
  pickerStyle,
} from "../../pages/AdminPanel/Products/formStyles";
import {
  daysFromUnit,
  pluralizeUnit,
  removeSelectedPlan,
  stepCount,
} from "../../utils/scheduling";

const removeStorageObjectUsage = httpsCallable(
  getFunctions(),
  "removeStorageObjectUsage",
);

const removePandaVideoUsage = httpsCallable(
  getFunctions(),
  "removePandaVideoUsage",
);

function pandaIdFromUrl(url) {
  if (!url || typeof url !== "string" || !url.includes("pandavideo")) {
    return null;
  }
  try {
    const parsed = new URL(url);
    const hashPath = parsed.hash ? parsed.hash.split("?")[0] : "";
    const dashboardMatch = hashPath.match(/\/videos\/([0-9a-f-]{36})/i);
    if (dashboardMatch) return dashboardMatch[1];
    const v = parsed.searchParams.get("v");
    return v || null;
  } catch {
    return null;
  }
}

function getUploadedPandaId(video) {
  const info = video?.videoInfo;
  if (info && typeof info === "object" && info.storage !== "firebase") {
    if (info.metadata?.id) return info.metadata.id;
    const fromUrl = pandaIdFromUrl(info.url);
    if (fromUrl) return fromUrl;
  }
  if (video?.pandaVideoMetadata?.id) return video.pandaVideoMetadata.id;
  if (video?.pandaVideoMetadata?.video_external_id) {
    return video.pandaVideoMetadata.video_external_id;
  }
  const fromMetaPlayer = pandaIdFromUrl(video?.pandaVideoMetadata?.video_player);
  if (fromMetaPlayer) return fromMetaPlayer;
  if (info === "CONVERTING" && video?.pandaUpload?.videoId) {
    return video.pandaUpload.videoId;
  }
  return null;
}

function hasUploadedMedia(video) {
  if (!video) return false;
  if (video.videoInfo === "CONVERTING") return true;
  if (video.videoInfo && typeof video.videoInfo === "object") return true;
  if (video.pandaUpload?.videoId) return true;
  if (
    video.pandaVideoMetadata?.video_external_id ||
    video.pandaVideoMetadata?.video_player
  ) {
    return true;
  }
  return false;
}

export function EditVideo(props) {
  const {
    video,
    onSave,
    isSaving,
    onClose,
    categoryId,
    videoId,
    cardId,
    user,
    plans,
    products,
  } = props;

  const { customInfo } = useCustomTheme();

  // Criar um novo array contendo os objetos plans e products
  const combinedArray = [];

  // Adicionar os objetos plans ao novo array
  if (Array.isArray(plans.plans)) {
    combinedArray.push(
      ...plans.plans.map((item) => ({ ...item, title: item.title })),
    );
  }

  // Adicionar os objetos products ao novo array
  if (Array.isArray(products)) {
    combinedArray.push(
      ...products.map((item) => ({
        ...item,
        title: `[${item.marketplace}] ${item?.title ? item.title : item.name}`,
      })),
    );
  }

  // Criar um novo array contendo apenas os títulos/nomes dos objetos
  const titlesArray = combinedArray.map((item) => {
    return item;
  });

  const videoUrl =
    video?.videoInfo?.url ||
    video?.pandaVideoMetadata?.video_player ||
    video?.link;

  const {
    title = "",
    url = "",
    meetingNumber = "",
    meetingPassword = "",
    link = "",
    description = [""],
    selectedPlans = [],
    selectedDate,
    isScheduling = null,
    isSchedulingNewStudents = null,
    pdf = [],
    liveStreamURLWeb = "",
    liveStreamURLMobile = "",
    type = "",
    liveDate: liveDateFromVideo,
    liveDuration: liveDurationFromVideo,
  } = video || {};

  const updatedSelectedDate = selectedDate
    ? new Date(selectedDate.seconds * 1000)
    : null;

  const planType = customInfo?.planType;
  const videoHosting = customInfo?.videoHosting;

  let updatedPdf;

  if (Array.isArray(pdf)) {
    updatedPdf = pdf;
  } else if (typeof pdf === "string" && pdf.trim() === "") {
    updatedPdf = [];
  } else if (typeof pdf === "string") {
    updatedPdf = [{ url: pdf, name: "" }];
  } else {
    updatedPdf = [pdf];
  }

  const [updatedVideo, setUpdatedVideo] = useState({
    title,
    url,
    meetingNumber: normalizeZoomMeetingNumber(meetingNumber),
    meetingPassword,
    link,
    description,
    selectedPlans,
    selectedDate: updatedSelectedDate,
    isScheduling,
    isSchedulingNewStudents,
    pdf: updatedPdf,
    liveStreamURLWeb,
    liveStreamURLMobile,
    type,
    liveDate: liveDateFromVideo?.seconds
      ? new Date(liveDateFromVideo.seconds * 1000)
      : null,
    liveDuration: liveDurationFromVideo ?? 0,
  });

  const descriptionInput = updatedVideo?.description || [""];
  const concatenatedDescription = descriptionInput?.join("\n");

  const [liveDateDate, setLiveDateDate] = useState(
    updatedVideo?.liveDate instanceof Date
      ? new Date(updatedVideo.liveDate)
      : null,
  );
  const [liveHour, setLiveHour] = useState(
    updatedVideo?.liveDate instanceof Date
      ? updatedVideo.liveDate.getHours()
      : 0,
  );
  const [liveMinute, setLiveMinute] = useState(
    updatedVideo?.liveDate instanceof Date
      ? updatedVideo.liveDate.getMinutes()
      : 0,
  );

  // 1) calcula a Date de término
  const initialEndDate =
    updatedVideo.liveDate instanceof Date && updatedVideo?.liveDuration
      ? new Date(
          updatedVideo?.liveDate.getTime() + updatedVideo?.liveDuration * 1000,
        )
      : null;

  // 2) inicializa apenas o HH e MM do término
  const [liveEndHour, setLiveEndHour] = useState(
    initialEndDate ? initialEndDate.getHours() : liveHour,
  );
  const [liveEndMinute, setLiveEndMinute] = useState(
    initialEndDate ? initialEndDate.getMinutes() : liveMinute,
  );
  // Video Upload
  const [showVideoUploadModal, setShowVideoUploadModal] = useState(false);
  const [showDeleteUploadModal, setShowDeleteUploadModal] = useState(false);
  const [isDeletingUpload, setIsDeletingUpload] = useState(false);
  const [deleteUploadError, setDeleteUploadError] = useState("");
  // PDF Upload
  const [showPDFUploadModal, setShowPDFUploadModal] = useState(false);

  const [showSaveSuccessAlert, setShowSaveSuccessAlert] = useState(false);

  const [selectedNumber, setSelectedNumber] = useState(
    video.schedulingDays ? video.schedulingDays : 0,
  );

  const [selectedUnit, setSelectedUnit] = useState("dia");

  const unitArray = ["dia", "semana", "mês"];

  const [dateMessageError, setDateMessageError] = useState(false);

  const [messageErrorSchedule, setMessageErrorSchedule] = useState(false);

  const [planMessageError, setPlanMessageError] = useState(false);

  const [checkBoxDate, setCheckBoxDate] = useState(
    video.isScheduling ? video.isScheduling : false,
  );
  const [checkBoxNewStudents, setcheckBoxNewStudents] = useState(
    video.isSchedulingNewStudents ? video.isSchedulingNewStudents : false,
  );

  const dateModal = new Date(video.selectedDate?.seconds * 1000);
  const dia = dateModal?.getDate();
  const mes = dateModal?.getMonth() + 1;
  const ano = dateModal?.getFullYear();

  const dateFullModal = `${dia}/${mes}/${ano}`;

  // ===== HELPERS =====
  const validateTime = (text, max) =>
    Math.min(max, Math.max(0, parseInt(text, 10) || 0));

  const updateField = (field, value) =>
    setUpdatedVideo((prev) => ({ ...prev, [field]: value }));

  const getMarkedDatesConfig = (date) => {
    if (!date) return {};
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    return {
      [formattedDate]: { selected: true, selectedColor: "#008000" },
    };
  };

  // Handlers da agenda da live — compartilhados por Zoom e Panda (ver
  // LiveScheduleFields), que antes repetiam esta lógica inline nos dois blocos.
  const handleLiveDateChange = (onlyDate) => {
    setLiveDateDate(onlyDate);
    const start = new Date(onlyDate);
    start.setHours(liveHour, liveMinute, 0, 0);
    setUpdatedVideo((v) => ({ ...v, liveDate: start }));
  };

  const handleLiveStartChange = ({ hour, minute }) => {
    setLiveHour(hour);
    setLiveMinute(minute);
    if (!liveDateDate) return;
    const start = new Date(liveDateDate);
    start.setHours(hour, minute, 0, 0);
    setUpdatedVideo((v) => ({ ...v, liveDate: start }));
    recalcDuration(hour, minute, liveEndHour, liveEndMinute);
  };

  const handleLiveEndChange = ({ hour, minute }) => {
    setLiveEndHour(hour);
    setLiveEndMinute(minute);
    recalcDuration(liveHour, liveMinute, hour, minute);
  };

  const handleDateSelect = (date) => {
    const today = new Date();
    const todayStart = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    );

    const selectedDate = new Date(date.timestamp);
    const offset = selectedDate.getTimezoneOffset();

    selectedDate.setMinutes(selectedDate.getMinutes() + offset);
    const selectedDateStart = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate(),
    );

    if (selectedDateStart >= todayStart) {
      setUpdatedVideo((prevVideo) => ({
        ...prevVideo,
        selectedDate: selectedDate,
      }));
      setDateMessageError(false);
    } else {
      setDateMessageError(true);
    }
  };

  const convertDaysSchedulingDays = (number) => {
    const schedulingDays = daysFromUnit(number, selectedUnit);

    if (checkBoxNewStudents) {
      setUpdatedVideo((prevVideo) => ({
        ...prevVideo,
        schedulingDays,
      }));
    }
  };

  useEffect(() => {
    convertDaysSchedulingDays(selectedNumber);
  }, [selectedUnit, selectedNumber]);

  const handleNumber = (text) => {
    // Allow clearing the field: an empty value resets to 0 instead of being
    // dropped (the old parseFloat('') -> NaN path left the previous number stuck).
    if (text === "") {
      setSelectedNumber(0);
      convertDaysSchedulingDays(0);
      return;
    }

    const parsedNumber = parseFloat(text);
    if (!isNaN(parsedNumber)) {
      setSelectedNumber(parsedNumber);
      convertDaysSchedulingDays(parsedNumber);
    }
  };

  useEffect(() => {
    if (liveDateDate) {
      const start = new Date(liveDateDate);
      start?.setHours(liveHour, liveMinute, 0, 0);
      const end = new Date(liveDateDate);
      end?.setHours(liveEndHour, liveEndMinute, 0, 0);
      const durationSec = Math.max(0, Math.floor((end - start) / 1000));
      setUpdatedVideo((v) => ({ ...v, duration: durationSec }));
    }
  }, [liveHour, liveMinute, liveEndHour, liveEndMinute, liveDateDate]);

  const incrementNumber = () => {
    const next = stepCount(selectedNumber, 1);
    setSelectedNumber(next);
    convertDaysSchedulingDays(next);
  };

  const decrementNumber = () => {
    // Clamp at 0 so a decrement at zero never persists a negative schedulingDays.
    const next = stepCount(selectedNumber, -1);
    setSelectedNumber(next);
    convertDaysSchedulingDays(next);
  };

  const handleOnSaveClick = async () => {
    const { isScheduling, selectedDate } = updatedVideo;

    if (isScheduling && selectedDate == null) {
      setMessageErrorSchedule(true);
    } else {
      const sanitizedVideo = {
        ...updatedVideo,
        meetingNumber: normalizeZoomMeetingNumber(updatedVideo?.meetingNumber),
      };
      setUpdatedVideo(sanitizedVideo);
      await onSave(sanitizedVideo);
      setMessageErrorSchedule(false);
      setShowSaveSuccessAlert(true);
    }
  };

  const handlePickerChange = (itemValue) => {
    if (itemValue !== "") {
      const selectedPlanObject = titlesArray.find(
        (item) => item.title === itemValue,
      );

      if (
        !updatedVideo.selectedPlans?.some(
          (item) => item.title === selectedPlanObject.title,
        )
      ) {
        //ALTEREI A IMPLEMENTAÇÃO DOS PLANOS AQUI
        setUpdatedVideo((prevVideo) => ({
          ...prevVideo,
          selectedPlans: [...prevVideo.selectedPlans, selectedPlanObject],
        }));
      }
    }
  };

  const updatedPlansInVideo = () => {
    setUpdatedVideo((prevVideo) => ({
      ...prevVideo,
      selectedPlans,
    }));
  };

  const handleCheckBoxDate = (value) => {
    updatedPlansInVideo();
    setCheckBoxDate(value);
    setcheckBoxNewStudents(false);
    value === true
      ? setUpdatedVideo(() => ({
          ...updatedVideo,
          isScheduling: value,
          isSchedulingNewStudents: !value,
        }))
      : setUpdatedVideo(() => ({
          ...updatedVideo,
          isScheduling: value,
        }));
  };

  const handleCheckBoxNewStudents = (value) => {
    updatedPlansInVideo();
    setcheckBoxNewStudents(value);
    setCheckBoxDate(false);
    value === true
      ? setUpdatedVideo(() => ({
          ...updatedVideo,
          isSchedulingNewStudents: value,
          isScheduling: !value,
        }))
      : setUpdatedVideo(() => ({
          ...updatedVideo,
          isSchedulingNewStudents: value,
        }));
  };

  const renderArrow = (direction) => {
    return (
      <View>
        <Text>{direction === "left" ? "<" : ">"}</Text>
      </View>
    );
  };

  LocaleConfig.locales["pt-br"] = {
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ],
    dayNames: [
      "Domingo",
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado",
    ],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    today: "Hoje",
  };

  LocaleConfig.defaultLocale = "pt-br";

  const namePdf = (item) => {
    if (!item.title && item.title !== "") {
      return item.name.slice(24);
    }
    if (item.name === item.title) {
      return item.name.slice(24);
    }
    return item.title;
  };

  function recalcDuration(startH, startM, endH, endM) {
    if (!liveDateDate) return;
    const start = new Date(liveDateDate);
    start.setHours(startH, startM, 0, 0);
    const end = new Date(liveDateDate);
    end.setHours(endH, endM, 0, 0);
    const sec = Math.max(
      0,
      Math.floor((end.getTime() - start.getTime()) / 1000),
    );
    setUpdatedVideo((v) => ({ ...v, liveDuration: sec }));
  }

  const handleDeleteUploadedVideo = async () => {
    setIsDeletingUpload(true);
    setDeleteUploadError("");

    try {
      const info = video?.videoInfo;
      const isFirebaseFile =
        info &&
        typeof info === "object" &&
        info.storage === "firebase" &&
        info.name;
      const pandaVideoId = isFirebaseFile ? null : getUploadedPandaId(video);

      // Primeiro a página deixa de apontar para o arquivo; depois o uso é
      // removido. A function confere o doc: se ele ainda apontasse, o uso
      // ficava (e o arquivo nunca seria apagado).
      const videoDocRef = doc(
        firestore,
        `categories/${categoryId}/cards/${cardId}/videos/${videoId}`,
      );
      await updateDoc(videoDocRef, {
        videoInfo: deleteField(),
        pandaUpload: deleteField(),
        pandaVideoMetadata: deleteField(),
      });
      setShowDeleteUploadModal(false);

      // A página já foi atualizada; falha do Panda/Storage a function
      // enfileira e refaz sozinha, então aqui só registra.
      try {
        if (isFirebaseFile) {
          await removeStorageObjectUsage({
            storagePath: info.name,
            categoryId,
            cardId,
            videoId,
          });
        } else if (pandaVideoId) {
          await removePandaVideoUsage({
            pandaVideoId,
            categoryId,
            cardId,
            videoId,
          });
        }
      } catch (usageError) {
        console.warn("Falha ao remover o uso do vídeo enviado:", usageError);
      }
    } catch (error) {
      console.error("Erro ao remover o vídeo enviado:", error);
      setDeleteUploadError(
        "Não foi possível excluir o vídeo enviado. Tente novamente.",
      );
      setShowDeleteUploadModal(false);
    } finally {
      setIsDeletingUpload(false);
    }
  };

  const renderUploadedVideoRemoval = () => {
    if (!hasUploadedMedia(video)) return null;

    return (
      <View style={{ marginTop: 12 }}>
        <ContentIcon
          onPress={() => {
            setDeleteUploadError("");
            setShowDeleteUploadModal(true);
          }}
        >
          <MaterialIcons name="delete-outline" size={24} color="black" />
          <FooterText color="black" padding="0.5rem">
            Excluir vídeo/áudio enviado
          </FooterText>
        </ContentIcon>
        <Text
          style={{
            fontFamily: ADMIN_FONT,
            fontSize: 12,
            color: ADMIN_COLORS.muted,
            marginTop: 6,
            lineHeight: 18,
          }}
        >
          Remove só o vídeo/áudio enviado nesta página de conteúdo. Se ele não
          estiver em uso em outra página, também é apagado do armazenamento. O
          restante da página permanece.
        </Text>
        {deleteUploadError ? (
          <InfoBanner variant="error">{deleteUploadError}</InfoBanner>
        ) : null}
      </View>
    );
  };

  const deletePdfFromStorage = async (pdfUrl) => {
    const entry = updatedVideo.pdf.find((p) => p.url === pdfUrl);
    let storagePath = entry?.name?.trim();
    if (!storagePath && pdfUrl?.includes?.("/o/")) {
      const enc = pdfUrl.split("/o/")[1].split("?")[0];
      try {
        storagePath = decodeURIComponent(enc);
      } catch {
        storagePath = enc;
      }
    }
    const filterPdf = updatedVideo.pdf.filter((pdf) => pdf.url !== pdfUrl);
    setUpdatedVideo((prevVideo) => ({
      ...prevVideo,
      pdf: filterPdf,
    }));

    // Primeiro o PDF sai da página; depois o uso é removido. A function
    // confere o doc: se ele ainda listasse o PDF, o uso ficava.
    const videoDocRef = doc(
      firestore,
      `categories/${categoryId}/cards/${cardId}/videos/${videoId}`,
    );
    const videoDoc = await getDoc(videoDocRef);

    if (videoDoc.exists()) {
      const pdfList = videoDoc?.data()?.pdf;
      const updatedPdfList = pdfList.filter((pdf) => pdf.url !== pdfUrl);
      await updateDoc(videoDocRef, { pdf: updatedPdfList });
    } else {
      console.error("Vídeo não encontrado no Firestore.");
    }

    if (!storagePath) return;
    try {
      await removeStorageObjectUsage({
        storagePath,
        categoryId,
        cardId,
        videoId,
      });
    } catch (e) {
      console.error("Erro ao remover uso do PDF no Storage:", e);
    }
  };

  const handleTitleChange = (text, index) => {
    const newPdf = [...updatedVideo.pdf];

    newPdf[index].title = text;

    setUpdatedVideo((prevState) => ({
      ...prevState,
      pdf: newPdf,
    }));
  };

  return (
    <Provider>
      <Container
        contentContainerStyle={{
          backgroundColor: ADMIN_COLORS.surfaceSubtle,
          padding: 24,
          flexGrow: 1,
        }}
      >
        <View style={{ width: "100%", maxWidth: 760, alignSelf: "center" }}>
          <TouchableOpacity
            onPress={onClose}
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 4,
              marginBottom: 12,
              alignSelf: "flex-start",
            }}
          >
            <Octicons
              name="chevron-left"
              size={18}
              color={ADMIN_COLORS.muted}
            />
            <Text
              style={{
                fontFamily: ADMIN_FONT,
                fontSize: 14,
                color: ADMIN_COLORS.muted,
              }}
            >
              Voltar
            </Text>
          </TouchableOpacity>
          <Text
            style={{
              fontFamily: ADMIN_FONT,
              fontSize: 22,
              fontWeight: "700",
              color: ADMIN_COLORS.ink,
              marginBottom: 4,
            }}
          >
            Alterar Informações
          </Text>
          <Text
            style={{
              fontFamily: ADMIN_FONT,
              fontSize: 14,
              color: ADMIN_COLORS.muted,
              marginBottom: 20,
              lineHeight: 20,
            }}
          >
            Edite o título, a descrição e o conteúdo (vídeo, áudio, PDF ou link)
            desta aula.
          </Text>

          <SectionCard title="Informações básicas">
            <Field>
              <FieldLabel>Título</FieldLabel>
              <AdminInput
                placeholder="Digitar título"
                value={updatedVideo.title}
                onChangeText={(value) =>
                  setUpdatedVideo(() => ({ ...updatedVideo, title: value }))
                }
              />
            </Field>
            {Array.isArray(description) && (
              <Field style={{ marginBottom: 0 }}>
                <FieldLabel>Descrição</FieldLabel>
                <AdminInput
                  multiline
                  placeholder="Digitar descrição"
                  value={concatenatedDescription}
                  onChangeText={(text) =>
                    setUpdatedVideo((prevState) => ({
                      ...prevState,
                      description: [text],
                    }))
                  }
                />
              </Field>
            )}
          </SectionCard>
          {video.type === "live" ? (
            <SectionCard title="Informações da aula ao vivo - Zoom">
              <Field>
                <FieldLabel>ID da Reunião</FieldLabel>
                <AdminInput
                  placeholder="Digitar ID"
                  value={updatedVideo.meetingNumber}
                  onChangeText={(value) =>
                    setUpdatedVideo(() => ({
                      ...updatedVideo,
                      meetingNumber: value,
                    }))
                  }
                />
              </Field>

              <Field>
                <FieldLabel>Password da Reunião</FieldLabel>
                <AdminInput
                  placeholder="Digitar o código após o 'pwd=' do link"
                  value={updatedVideo.meetingPassword}
                  onChangeText={(value) =>
                    setUpdatedVideo(() => ({
                      ...updatedVideo,
                      meetingPassword: value,
                    }))
                  }
                />
              </Field>

              <LiveScheduleFields
                liveDate={liveDateDate}
                startHour={liveHour}
                startMinute={liveMinute}
                endHour={liveEndHour}
                endMinute={liveEndMinute}
                onChangeDate={handleLiveDateChange}
                onChangeStart={handleLiveStartChange}
                onChangeEnd={handleLiveEndChange}
                renderArrow={renderArrow}
              />

              {renderUploadedVideoRemoval()}

              <PDFUploader
                setShowPDFUploadModal={setShowPDFUploadModal}
                updatedVideo={updatedVideo}
                namePdf={namePdf}
                handleTitleChange={handleTitleChange}
                deletePdfFromStorage={deletePdfFromStorage}
              />
            </SectionCard>
          ) : video.type === "content" ? (
            <SectionCard title="Vídeo ou áudio">
              <Field style={{ marginBottom: 0 }}>
                <FieldLabel>
                  Link do vídeo/áudio (YouTube, Vimeo ou Panda)
                </FieldLabel>
                <AdminInput
                  placeholder="Colar link do Youtube, Vimeo ou Panda"
                  value={updatedVideo?.link}
                  onChangeText={(value) =>
                    setUpdatedVideo(() => ({ ...updatedVideo, link: value }))
                  }
                />
              </Field>
              {(planType === "growth" ||
                planType === "premium" ||
                videoHosting === "ownPanda") &&
              videoHosting !== "ownVimeo" ? (
                <>
                  <SmallText
                    textAlign="center"
                    color={ADMIN_COLORS.muted}
                    margin="1rem 0rem 0.5rem"
                  >
                    OU
                  </SmallText>
                  <SmallText textAlign="flex-start" color={ADMIN_COLORS.label}>
                    Adicione um vídeo/áudio no banco de dados:
                  </SmallText>

                  {video.videoInfo === "CONVERTING" ? (
                    <View style={{ alignItems: "center" }}>
                      <SmallText textAlign="center" color="black">
                        Seu vídeo está sendo convertido e logo estará disponível
                        aqui
                      </SmallText>
                      <View>
                        <ActivityIndicator
                          style={{ marginTop: 10 }}
                          size="small"
                          color="black"
                        />
                      </View>
                    </View>
                  ) : (
                    <ContentIcon onPress={() => setShowVideoUploadModal(true)}>
                      <MaterialIcons
                        name="drive-folder-upload"
                        size={24}
                        color="black"
                      />
                      <FooterText color="black" padding="0.5rem">
                        Upload Vídeo/Áudio
                      </FooterText>
                    </ContentIcon>
                  )}
                </>
              ) : (
                <></>
              )}
              {renderUploadedVideoRemoval()}
              {videoUrl && (
                <ViewVideo>
                  <VideoPlayer video={video} />
                </ViewVideo>
              )}
              <PDFUploader
                setShowPDFUploadModal={setShowPDFUploadModal}
                updatedVideo={updatedVideo}
                namePdf={namePdf}
                handleTitleChange={handleTitleChange}
                deletePdfFromStorage={deletePdfFromStorage}
              />
              <Modal
                animationType="fade"
                transparent={false}
                visible={showVideoUploadModal}
                onRequestClose={() => {
                  setShowVideoUploadModal(false);
                }}
              >
                <VideoUpload
                  url={videoUrl}
                  onUploadCompleted={() => setShowVideoUploadModal(true)}
                  onClose={() => setShowVideoUploadModal(false)}
                  metadata={{
                    databasePath: `/categories/${categoryId}/cards/${cardId}/videos/${videoId}`,
                    databasePropName: "videoInfo",
                    categoryId,
                    cardId,
                    videoId,
                  }}
                  user={user}
                  video={video}
                ></VideoUpload>
              </Modal>
            </SectionCard>
          ) : video.type === "livestream" ? (
            <>
              <SectionCard title="Informações da aula ao vivo - Panda">
                <Field>
                  <FieldLabel>URL da Live - App Web</FieldLabel>
                  <AdminInput
                    placeholder="Colar link embed do Panda"
                    keyboardType="default"
                    returnKeyType="go"
                    value={updatedVideo?.liveStreamURLWeb}
                    onChangeText={(value) =>
                      updateField("liveStreamURLWeb", value)
                    }
                  />
                </Field>

                <Field>
                  <FieldLabel>
                    URL da Live - App Mobile (iOS & Android)
                  </FieldLabel>
                  <AdminInput
                    placeholder="Colar link HLS do Panda"
                    keyboardType="default"
                    returnKeyType="go"
                    value={updatedVideo?.liveStreamURLMobile}
                    onChangeText={(value) =>
                      updateField("liveStreamURLMobile", value)
                    }
                  />
                </Field>

                <LiveScheduleFields
                  liveDate={liveDateDate}
                  startHour={liveHour}
                  startMinute={liveMinute}
                  endHour={liveEndHour}
                  endMinute={liveEndMinute}
                  onChangeDate={handleLiveDateChange}
                  onChangeStart={handleLiveStartChange}
                  onChangeEnd={handleLiveEndChange}
                  renderArrow={renderArrow}
                />

                {renderUploadedVideoRemoval()}

                <PDFUploader
                  setShowPDFUploadModal={setShowPDFUploadModal}
                  updatedVideo={updatedVideo}
                  namePdf={namePdf}
                  handleTitleChange={handleTitleChange}
                  deletePdfFromStorage={deletePdfFromStorage}
                />
              </SectionCard>

              <Modal
                animationType="fade"
                transparent={false}
                visible={showVideoUploadModal}
                onRequestClose={() => {
                  setShowVideoUploadModal(false);
                }}
              >
                <VideoUpload
                  url={videoUrl}
                  onUploadCompleted={() => setShowVideoUploadModal(true)}
                  onClose={() => setShowVideoUploadModal(false)}
                  metadata={{
                    databasePath: `/categories/${categoryId}/cards/${cardId}/videos/${videoId}`,
                    databasePropName: "videoInfo",
                    categoryId,
                    cardId,
                    videoId,
                  }}
                  user={user}
                  video={video}
                ></VideoUpload>
              </Modal>
            </>
          ) : null}
          <SectionCard title="Link de acesso externo (opcional)">
            <Field style={{ marginBottom: 0 }}>
              <FieldLabel>Link de acesso externo</FieldLabel>
              <AdminInput
                placeholder="https://..."
                value={updatedVideo.url}
                onChangeText={(value) =>
                  setUpdatedVideo(() => ({ ...updatedVideo, url: value }))
                }
              />
              <Text
                style={{
                  fontFamily: ADMIN_FONT,
                  fontSize: 12,
                  color: ADMIN_COLORS.muted,
                  marginTop: 6,
                }}
              >
                Cole um link de acesso externo começando com "https://".
              </Text>
              <InfoBanner variant="info">
                Use esse campo para adicionar links para formulários, grupos do
                whatsapp, venda de produtos físicos, etc.
              </InfoBanner>
            </Field>
          </SectionCard>
          {video?.type === "content" && (
            <SectionCard
              title="Agendar liberação do conteúdo (opcional)"
              subtitle="Escolha quando esse conteúdo fica disponível para o aluno — por plano, para novos alunos ou numa data fixa."
            >
              {titlesArray?.length > 0 && (
                <Field>
                  <FieldLabel>
                    Plano em que esse conteúdo será liberado para o aluno
                  </FieldLabel>
                  <Picker
                    mode="dropdown"
                    onValueChange={handlePickerChange}
                    style={pickerStyle}
                  >
                    <Picker.Item label="Selecione um plano..." value="" />
                    {titlesArray.map((item, index) => (
                      <Picker.Item
                        key={index}
                        label={item.title}
                        value={item.title}
                      />
                    ))}
                  </Picker>

                  {updatedVideo.selectedPlans?.length > 0 && (
                    <View
                      style={{
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: 8,
                        marginTop: 10,
                      }}
                    >
                      {updatedVideo.selectedPlans.map((plan, index) => (
                        <Chip
                          key={index}
                          onClose={() =>
                            setUpdatedVideo((prevVideo) => ({
                              ...prevVideo,
                              selectedPlans: removeSelectedPlan(
                                prevVideo.selectedPlans,
                                plan,
                              ),
                            }))
                          }
                          style={{ backgroundColor: ADMIN_COLORS.accentSoft }}
                          textStyle={{
                            color: ADMIN_COLORS.accentDark,
                            fontFamily: ADMIN_FONT,
                          }}
                        >
                          {plan.title}
                        </Chip>
                      ))}
                    </View>
                  )}

                  {video.isScheduling && (
                    <Text
                      style={{
                        fontFamily: ADMIN_FONT,
                        fontSize: 13,
                        color: ADMIN_COLORS.muted,
                        marginTop: 10,
                      }}
                    >
                      Este conteúdo foi agendado para{" "}
                      <Text
                        style={{ fontWeight: "700", color: ADMIN_COLORS.ink }}
                      >
                        {dateFullModal}
                      </Text>
                    </Text>
                  )}
                  {video.isSchedulingNewStudents && (
                    <Text
                      style={{
                        fontFamily: ADMIN_FONT,
                        fontSize: 13,
                        color: ADMIN_COLORS.muted,
                        marginTop: 10,
                      }}
                    >
                      Este conteúdo foi agendado para{" "}
                      <Text
                        style={{ fontWeight: "700", color: ADMIN_COLORS.ink }}
                      >
                        {video.schedulingDays} dias após a criação da conta
                      </Text>
                    </Text>
                  )}
                </Field>
              )}

              <Row>
                <Col>
                  <View
                    style={{
                      backgroundColor: ADMIN_COLORS.surfaceSubtle,
                      borderWidth: 1,
                      borderColor: ADMIN_COLORS.border,
                      borderRadius: ADMIN_COLORS.radius,
                      padding: 16,
                      height: "100%",
                      opacity: checkBoxDate ? 0.5 : 1,
                    }}
                  >
                    <CheckBox
                      title="Liberação para novos alunos"
                      checked={checkBoxNewStudents}
                      onPress={() => {
                        updatedVideo?.selectedPlans?.length < 1
                          ? setPlanMessageError(true)
                          : (handleCheckBoxNewStudents(!checkBoxNewStudents),
                            setPlanMessageError(false));
                      }}
                      checkedColor={ADMIN_COLORS.accent}
                      uncheckedColor={ADMIN_COLORS.muted}
                      containerStyle={{
                        backgroundColor: "transparent",
                        borderWidth: 0,
                        paddingVertical: 0,
                        paddingHorizontal: 0,
                        marginLeft: 0,
                        marginRight: 0,
                      }}
                      textStyle={{
                        fontFamily: ADMIN_FONT,
                        color: ADMIN_COLORS.ink,
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    />

                    {planMessageError && (
                      <InfoBanner variant="error">
                        Selecione acima os planos para os quais deseja agendar a
                        liberação.
                      </InfoBanner>
                    )}

                    <Text
                      style={{
                        fontFamily: ADMIN_FONT,
                        fontSize: 13,
                        color: ADMIN_COLORS.muted,
                        marginTop: 12,
                        marginBottom: 10,
                      }}
                    >
                      Selecione após quantos dias esse conteúdo será liberado
                      para novos alunos:
                    </Text>

                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <View
                        style={{ flexDirection: "row", alignItems: "center" }}
                      >
                        <AdminInput
                          style={{ width: 64, textAlign: "center" }}
                          editable={!checkBoxDate && checkBoxNewStudents}
                          keyboardType="numeric"
                          value={String(selectedNumber)}
                          onChangeText={handleNumber}
                        />
                        <View style={{ marginLeft: 6 }}>
                          <TouchableOpacity
                            style={{
                              width: 26,
                              height: 20,
                              borderRadius: 6,
                              borderWidth: 1,
                              borderColor: ADMIN_COLORS.border,
                              backgroundColor: ADMIN_COLORS.surface,
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onPress={incrementNumber}
                            disabled={checkBoxDate || !checkBoxNewStudents}
                          >
                            <Octicons
                              name="chevron-up"
                              size={12}
                              color={ADMIN_COLORS.muted}
                            />
                          </TouchableOpacity>
                          <TouchableOpacity
                            style={{
                              width: 26,
                              height: 20,
                              borderRadius: 6,
                              borderWidth: 1,
                              borderColor: ADMIN_COLORS.border,
                              backgroundColor: ADMIN_COLORS.surface,
                              alignItems: "center",
                              justifyContent: "center",
                              marginTop: 4,
                            }}
                            disabled={checkBoxDate || !checkBoxNewStudents}
                            onPress={decrementNumber}
                          >
                            <Octicons
                              name="chevron-down"
                              size={12}
                              color={ADMIN_COLORS.muted}
                            />
                          </TouchableOpacity>
                        </View>
                      </View>

                      <Picker
                        mode="dropdown"
                        selectedValue={selectedUnit}
                        onValueChange={(itemValue) =>
                          setSelectedUnit(itemValue)
                        }
                        enabled={!checkBoxDate && checkBoxNewStudents}
                        style={{ ...pickerStyle, flex: 1, marginTop: 0 }}
                      >
                        {unitArray.map((unit) => (
                          <Picker.Item
                            key={unit}
                            label={pluralizeUnit(unit, selectedNumber)}
                            value={unit}
                          />
                        ))}
                      </Picker>
                    </View>
                  </View>
                </Col>

                <Col>
                  <View
                    style={{
                      backgroundColor: ADMIN_COLORS.surfaceSubtle,
                      borderWidth: 1,
                      borderColor: ADMIN_COLORS.border,
                      borderRadius: ADMIN_COLORS.radius,
                      padding: 16,
                      height: "100%",
                      opacity: checkBoxNewStudents ? 0.5 : 1,
                    }}
                  >
                    <CheckBox
                      title="Liberação por data"
                      checked={checkBoxDate}
                      onPress={() => handleCheckBoxDate(!checkBoxDate)}
                      checkedColor={ADMIN_COLORS.accent}
                      uncheckedColor={ADMIN_COLORS.muted}
                      containerStyle={{
                        backgroundColor: "transparent",
                        borderWidth: 0,
                        paddingVertical: 0,
                        paddingHorizontal: 0,
                        marginLeft: 0,
                        marginRight: 0,
                      }}
                      textStyle={{
                        fontFamily: ADMIN_FONT,
                        color: ADMIN_COLORS.ink,
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    />

                    <View style={{ marginTop: 12 }}>
                      <Calendar
                        onDayPress={
                          !checkBoxNewStudents && checkBoxDate
                            ? handleDateSelect
                            : undefined
                        }
                        theme={{
                          todayTextColor: ADMIN_COLORS.accent,
                          arrowColor: ADMIN_COLORS.accent,
                          selectedDayBackgroundColor: ADMIN_COLORS.accent,
                          textDayFontFamily: ADMIN_FONT,
                          textMonthFontFamily: ADMIN_FONT,
                          textDayHeaderFontFamily: ADMIN_FONT,
                        }}
                        {...(updatedVideo.selectedDate instanceof Date &&
                          !isNaN(updatedVideo.selectedDate.getTime()) && {
                            markedDates: {
                              [updatedVideo.selectedDate
                                .toISOString()
                                .split("T")[0]]: {
                                selected: true,
                                selectedColor: ADMIN_COLORS.accent,
                              },
                            },
                          })}
                        renderArrow={renderArrow}
                      />

                      {messageErrorSchedule && (
                        <InfoBanner variant="error">
                          Para realizar um agendamento você precisa selecionar
                          pelo menos uma data.
                        </InfoBanner>
                      )}

                      {dateMessageError && (
                        <InfoBanner variant="error">
                          Não é permitido selecionar uma data anterior à data de
                          hoje.
                        </InfoBanner>
                      )}
                    </View>
                  </View>
                </Col>
              </Row>
            </SectionCard>
          )}
          <ConfirmDeleteModal
            visible={showDeleteUploadModal}
            title="Excluir vídeo/áudio enviado?"
            entityLabel="Arquivo enviado"
            entityName={video?.title}
            description="O arquivo enviado será removido só desta página. Se ele não estiver em uso em outro conteúdo, também é apagado do armazenamento. Título, descrição, link e PDF permanecem — você pode colar um link de YouTube, Vimeo ou Panda no lugar."
            confirmLabel="Excluir vídeo enviado"
            isLoading={isDeletingUpload}
            onConfirm={handleDeleteUploadedVideo}
            onCancel={() => {
              if (!isDeletingUpload) setShowDeleteUploadModal(false);
            }}
          />
          <AlertBox variant="admin"
            message={"Alteração feita com sucesso! :)"}
            visible={showSaveSuccessAlert}
            leftButtonFunction={onClose}
            onClose={onClose}
            leftButton={"OK"}
          />
          <Modal
            animationType="fade"
            transparent={true}
            visible={showPDFUploadModal}
            onRequestClose={() => {
              setShowPDFUploadModal(false);
            }}
          >
            <PdfUpload
              onUploadCompleted={() => setShowPDFUploadModal(true)}
              onClose={() => setShowPDFUploadModal(false)}
              metadata={{
                databasePath: `/categories/${categoryId}/cards/${cardId}/videos/${videoId}`,
                databasePropName: "pdf",
              }}
              updatedPdf={setUpdatedVideo}
            ></PdfUpload>
          </Modal>
          <View style={styles.actions}>
            <Pressable
              onPress={onClose}
              disabled={isSaving}
              style={({ hovered }) => [
                styles.btn,
                styles.btnSecondary,
                hovered && { backgroundColor: "#E5E7EB" },
              ]}
            >
              <Text
                style={[styles.btnText, { color: ADMIN_COLORS.secondaryText }]}
              >
                Cancelar
              </Text>
            </Pressable>
            <Pressable
              onPress={handleOnSaveClick}
              disabled={isSaving}
              style={({ hovered }) => [
                styles.btn,
                styles.btnPrimary,
                hovered && { backgroundColor: ADMIN_COLORS.accentDark },
                isSaving && { opacity: 0.7 },
              ]}
            >
              <Text
                style={[styles.btnText, { color: ADMIN_COLORS.primaryText }]}
              >
                {isSaving ? "Salvando..." : "Salvar"}
              </Text>
            </Pressable>
          </View>
        </View>
      </Container>
    </Provider>
  );
}

const styles = StyleSheet.create({
  actions: {
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 12,
    marginTop: 4,
    marginBottom: 24,
  },
  btn: {
    minHeight: 44,
    borderRadius: 10,
    paddingHorizontal: 22,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  btnPrimary: { backgroundColor: ADMIN_COLORS.accent },
  btnSecondary: { backgroundColor: ADMIN_COLORS.secondaryBg },
  btnText: { fontFamily: ADMIN_FONT, fontSize: 14, fontWeight: "600" },
});
